import { useState, useCallback, useEffect } from "react";
import { navigationRef } from "src/hooks/navigation";
import { atom, useRecoilValue } from "recoil";

export const useDeeplink = () => {
  const route = useCallback(async (payload: any) => {
    if (payload.type === "identification") {
      navigationRef.current?.navigate("Main", { screen: "MyPage" });
    } else if (payload.type === "notification") {
      navigationRef.current?.navigate("Notification", {
        id: payload.notificationId,
      });
    } else if (payload.type === "request") {
      setTimeout(() => {
        navigationRef.current?.navigate("Call");
      }, 1500); // TODO: Find better solution
    } else if (payload.type === "request-cancel") {
      // do nothing, logic on native side
      // TODO: Add android logic
    } else if (payload.type === "reoffer") {
      navigationRef.current?.navigate("CallHistory", {
        callId: payload.requestId,
      });
    } else if (payload.type === "withdrawal") {
      // TODO: redirect to withdrawal {salesId}
    } else if (payload.type === "preOffer") {
      navigationRef.current?.navigate("PreOfferChat", {
        preOfferId: payload.conversationId,
      });
    } else if (payload.type === "callChat") {
      // TODO: emit event to open in talk chat
    } else if (payload.type === "request-rejected") {
      navigationRef.current?.navigate("CallHistory", {
        callId: payload.requestId,
      });
    }
  }, []);

  return { route } as const;
};
